import { inject, Injectable } from "@angular/core";
import { Locale, UserLocaleResolver } from "@ubisolutions/base";
import Keycloak from "keycloak-js";
import { from, Observable } from "rxjs";

/**
 * The locale of the user's Keycloak profile.
 */
@Injectable()
export class CtUserLocaleResolver implements UserLocaleResolver {
    private readonly keycloakService = inject(Keycloak);

    resolve(): Observable<Locale | null> {
        const localePromise = this.keycloakService.loadUserInfo()
            .then((profile) => {
                const loadedProfile = profile as Record<string, unknown>;
                const profileLocale = loadedProfile["locale"];
                if (typeof profileLocale === "string") {
                    return profileLocale;
                } else {
                    return null;
                }
            });

        return from(localePromise);
    }
}
